class ParentChildCtrl {
  constructor(SchemaService, AuthService, EventService, TemplateService, $window, $timeout) {
    'ngInject';
    this.ss = SchemaService;
    this.as = AuthService;
    this.ts = TemplateService;
    this.es = EventService;
    this.$window = $window;
    this.$timeout = $timeout;

    this.selectedTableName = '';
    this.fields = {};
    this.messages = [];
    this.relation = {};
    this.formState = 'initial';
    this.importedConnections = {};
    this.validNewConnections = true;
    this.loading = true;
    this.collapsed = true;

    this.newAction = (records) => {
      this.formState = 'add';
    };
    
    this.columns = [
      { 
        'header': ' ', 
        'key': 'delete', 
        'format': (value) => '<i class="fa fa-trash text-danger"></i>',
        'style': { 'width': '25px', 'padding': '8px', 'overflow': 'initial'},
        'onClick': (value, relation) => this.removeRelation(relation, this.td.template.relations)
      },
      { 
        'header': 'Parent', 
        'key': 'parentId', 
        'format': (value) => this.getRefName(value)
      },
      { 
        'header': 'Child', 
        'key': 'childId', 
        'format': (value) => this.getRefName(value)
      },
      { 
        'header': 'Field', 
        'key': 'fieldId',
        'format': (fieldId, idx, {childId}) => {
          const {"tableSchema": {fields}} = this.getRef(childId);
          return fields.find(({id})=> fieldId == id).label;
        }
      }
    ];
  }

  async $onInit() {
    try {
      [this.PROVIDER, this.td] = await Promise.all([
        this.as.getProviderSettings(),
        this.ts.getTemplateData()
      ]);
      this.loadConnections();

      this.templateId = this.ts.templateId;
      this.initRelation();
      this.loading = false;
      
    } catch (error) {
      this.handleError(error, 'During Page Setup');
    }
  }

  handleSubmit(relation) {
    this.collapsed = false;
    this.formState === 'add' ? this.addRelation(relation) : this.addRelations();
    this.formState = 'initial';
  }

  loadConnections() {
    this.buildImportConnections(this.ss.schemas);
  }

  buildImportConnections(schemas) {
    // this.formState = 'import';
    this.availableConnections = false;
    this.importedConnections = {};
    
    this.td.template.references.forEach((ref) => {
      (schemas[ref.tableId].foreignKeys || []).forEach((fk) => {

        if (this.td.template.relations.some(r => r.childId === ref.id && fk.fieldId === r.fieldId)) return;

        const parentRefs = this.td.template.references
          .filter(pr => (pr.id !== ref.id && pr.tableId === fk.tableId) )
          .map(pr => {return({ parentRefId: pr.id, parentRefName: pr.name });});

        const childField = schemas[ref.tableId].fields.find(f => f.id === fk.fieldId);

        if (parentRefs.length > 0 && childField) {

          let parentRef = null;
          parentRefs.unshift({ parentRefId: 'skip', parentRefName: '--SKIP--' });

          if (parentRefs.length > 2) {
            parentRefs.unshift({ parentRefId: null, parentRefName: '--RESOLVE--' });
            parentRef = parentRefs[0];
            this.validNewConnections = false;
          }
          else {
            parentRef = parentRefs[1];
          }
          
          this.importedConnections[ref.id] = this.importedConnections[ref.id] || { tableName: ref.name, newRelations: []};
          this.importedConnections[ref.id].newRelations.push({
            parentRefs, 
            parentRef, 
            childRefId: ref.id, 
            childFieldId: fk.fieldId, 
            childFieldName: childField.label
          });
          this.availableConnections = true;
        }
      });
    });
  }

  showImportableConnection(){
    this.loadConnections(this.ss.schemas);
    this.formState = 'import';
  }

  initRelation() {
    this.relation = { 
      templateId: this.templateId,
      realm: this.td.template.realm,
      provider: this.td.template.provider,
    };
  }

  back() {
    this.collapsed = false;
    this.formState = 'initial';
  }

  getRefName(key){
    return this.getRef(key)['name'];
  }

  getRef(key) {
    return this.td.template.references.find(r => r.id === key) || {};
  }

  async childSelected(childId) {
    try {
      this.fields = {}; // Clear while 'awaiting'
      const { tableId } = this.getRef(childId);
      if (!tableId) { return }
      const schema = await this.ss.getSchema(this.td.template, tableId);
      this.fields = schema.fields;
    } catch (error) {
      this.handleError(error, 'Loading Table Information');
    }
  }

  handleError(error, when) {
    const message = `An Error occurred ${when}. Message: ${error.message}.`;
    this.messages.push({ message, class: 'alert-danger' });
    console.error(error);
  }

  removeRelation(relation) {
    try {
      if( !this.$window.confirm('Are you sure you want to delete the connection?') ) return;
      this.td.template.relations = this.td.template.relations.filter(r => r.id !== relation.id);
      const message = `Connection removed.`;
      this.messages.push({ message, class: 'alert-success', closeInSeconds: 5 });
      this.updateTemplateData();
    } catch (error) {
      this.handleError(error, 'When removing the Table Connection.');
    }
  }

  validForm(state) {
    return this.formState === 'add' ? state : !this.validNewConnections;
  }

  updateRelationsValidity() {
    let cont = 0;
    this.validNewConnections = true;
    Object.keys(this.importedConnections)
      .forEach(ref => { 
        cont += this.importedConnections[ref].newRelations.filter(i => i.parentRef.parentRefId !== null && i.parentRef.parentRefId !== 'skip').length;
        this.validNewConnections = this.validNewConnections && !this.importedConnections[ref].newRelations.some(i => i.parentRef.parentRefId === null); 
      });
    this.validNewConnections = this.validNewConnections && (cont>0);
  }

  addRelation(relation) {
    try {
      this.td.template.relations.push(this.ts.initializeNewObject(relation));
      this.updateTemplateData();
    } catch (error) {
      this.handleError(error, 'When connecting the Tables.');
    }
  }

  async addRelations() {

    const relPromises = [];

    Object.keys(this.importedConnections).forEach((childRefId) => {
      this.importedConnections[childRefId].newRelations.forEach((rel) => {
        if (rel.parentRef?.parentRefId && rel.parentRef.parentRefId !=='skip') {
          const newRel = this.ts.initializeNewObject({ 
            ...this.relation, 
            childId: childRefId, 
            fieldId: rel.childFieldId, 
            parentId: rel.parentRef.parentRefId, 
          });

          this.td.template.relations.push(newRel);
        }
      });
    });

    try {
      await Promise.all(relPromises);
      this.updateTemplateData();
    } catch (error) {
      this.handleError(error, 'When connecting the Tables.');
    }
  }

  filterFields(relation, relations){
    return (field) => {
      return ((field.isForeignKey || field.isPrimaryKey) && !relations.find(rel => {
        return relation.childId === rel.childId
          && relation.parentId === rel.parentId
          && field.id === rel.fieldId;
      }));
    };
  }

  updateTemplateData() {
    this.$timeout(() => {
      this.ts.notifyUpdate(["relations"], { template: { relations: this.td.template.relations } } );
    });
    this.loadConnections(this.ss.schemas);
    this.initRelation();
  }

  collapseGroupPanels(group) {
    $(`${group} .panel-collapse`).collapse('hide');
  }

}

export default {
  bindings: {
  },
  templateUrl: 'form-builder/build-wizard/parent-child/parent-child.component.html',
  controller: ParentChildCtrl
};
